import { render, staticRenderFns } from "./PersonalProfesionalizacion.vue?vue&type=template&id=1c356469&scoped=true"
import script from "./PersonalProfesionalizacion.vue?vue&type=script&lang=js"
export * from "./PersonalProfesionalizacion.vue?vue&type=script&lang=js"
import style0 from "./PersonalProfesionalizacion.vue?vue&type=style&index=0&id=1c356469&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c356469",
  null
  
)

export default component.exports